import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

import * as fragments from '../../../employees/gql/fragments'
import type { Entity } from '../../record/types'
import * as enums from '../enums'

export const DOC = gql`
  ${fragments.employee.DOC}
  fragment FragmentOccupant on SpaceOccupant {
    id
    employee {
      ...FragmentSpaceEmployee
    }
    payrolls {
      payrollIds
      assignment
      percent
      project {
        code
        name
      }
      organization {
        name
      }
      idcAllocations {
        idcCategorization {
          category {
            code
          }
          subcategory {
            code
          }
        }
        percent
      }
    }
  }
`

export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentOccupantFragment,
  Entity
>({
  employee: graphql.transformers.OUT.nonNull(fragments.employee.TRANSFORMER),
  id: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    ents.core.dms.data.Record.Id.isId,
  ),
  payrolls: graphql.transformers.OUT.default(
    graphql.transformers.OUT.list(
      graphql.transformers.OUT.object({
        assignment: enums.payrollAssignment.TRANSFORMER,
        idcAllocations: graphql.transformers.OUT.default(
          graphql.transformers.OUT.list(
            graphql.transformers.OUT.object({
              idcCategorization: graphql.transformers.OUT.nonNull(
                graphql.transformers.OUT.object({
                  category: graphql.transformers.OUT.nonNull(
                    graphql.transformers.OUT.object({
                      code: transformers.PASS_THROUGH,
                    }),
                  ),
                  subcategory: graphql.transformers.OUT.object({
                    code: transformers.PASS_THROUGH,
                  }),
                }),
              ),
              percent: transformers.PASS_THROUGH,
            }),
            { onNullish: 'remove' },
          ),
          [],
        ),
        organization: graphql.transformers.OUT.nonNull(
          graphql.transformers.OUT.object({
            name: transformers.PASS_THROUGH,
          }),
        ),
        payrollIds: graphql.transformers.OUT.default(
          graphql.transformers.OUT.list(
            graphql.transformers.OUT.validate(
              transformers.PASS_THROUGH,
              ents.extra.space.Payroll.Id.isId,
            ),
            { onNullish: 'remove' },
          ),
          [],
        ),
        percent: transformers.PASS_THROUGH,
        project: graphql.transformers.OUT.object({
          code: transformers.PASS_THROUGH,
          name: transformers.PASS_THROUGH,
        }),
      }),
      { onNullish: 'remove' },
    ),
    [],
  ),
})
